export interface PaymentResponseData {
  GolPayLink?: {
    $t?: unknown;
  };
  PaymentRedirectRequired?: {
    $t?: unknown;
  };
}

export interface PaymentRequestResult {
  success?: boolean;
  data?: PaymentResponseData | null;
  errorMsg?: string;
}

interface PaymentNavigationError {
  hasPaymentRedirectRequired: boolean;
  hasPaymentUrl: boolean;
  paymentRedirectRequired: unknown;
}

export function handlePaymentNavigation({
  responseData,
  navigateToPayment,
  redirectToBooked,
  onError,
}: {
  responseData?: PaymentResponseData | null;
  navigateToPayment: (paymentUrl: string) => unknown;
  redirectToBooked: () => unknown;
  onError: (error: PaymentNavigationError) => unknown;
}) {
  const rawPaymentUrl = responseData?.GolPayLink?.$t;
  const paymentUrl =
    typeof rawPaymentUrl === "string" ? rawPaymentUrl.trim() : "";
  const hasPaymentRedirectRequired = Boolean(
    responseData &&
      Object.prototype.hasOwnProperty.call(
        responseData,
        "PaymentRedirectRequired"
      )
  );
  const paymentRedirectRequired = responseData?.PaymentRedirectRequired?.$t;

  if (
    (!hasPaymentRedirectRequired || paymentRedirectRequired === "true") &&
    paymentUrl
  ) {
    return navigateToPayment(paymentUrl);
  }

  if (paymentRedirectRequired === "false" && !paymentUrl) {
    return redirectToBooked();
  }

  return onError({
    hasPaymentRedirectRequired,
    hasPaymentUrl: Boolean(paymentUrl),
    paymentRedirectRequired,
  });
}

export function handlePaymentResult({
  result,
  navigateToPayment,
  redirectToBooked,
  onRequestError,
  onNavigationError,
}: {
  result: PaymentRequestResult;
  navigateToPayment: (paymentUrl: string) => unknown;
  redirectToBooked: () => unknown;
  onRequestError: (errorMsg?: string) => unknown;
  onNavigationError: (error: PaymentNavigationError) => unknown;
}) {
  if (!result.success) {
    return onRequestError(result.errorMsg);
  }

  return handlePaymentNavigation({
    responseData: result.data,
    navigateToPayment,
    redirectToBooked,
    onError: onNavigationError,
  });
}
